import axiosInstance from "./AxiosInstance";

export function getVehicleListApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`/api/vehicles?${fparam}`);
}

export function createVehicleApi(data) {
  return axiosInstance.post(`/api/vehicles`, data);
}
export function updateVehicleApi(id,data) {
  return axiosInstance.put(`/api/vehicles/${id}`, data);
}
export function deleteVehicleApi(id) {
  return axiosInstance.delete(`/api/vehicles/${id}`);
}

export function getBrandApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/vehicle/brands?${fparam}`);
}

export function createBrandApi(data) {
  return axiosInstance.post("api/vehicle/brands", data);
}

export function editBrandApi(id,data) {
  return axiosInstance.put(`api/vehicle/brands/${id}`, data);
}

export function deleteBrandApi(id) {
  return axiosInstance.delete(`api/vehicle/brands/${id}`);
}

export function getModelApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/vehicle/models?${fparam}`);
}

export function createModelApi(data) {
  return axiosInstance.post("api/vehicle/models", data);
}

export function editModelApi(id,data) {
  return axiosInstance.put(`api/vehicle/models/${id}`, data);
}

export function deleteModelApi(id) {
  return axiosInstance.delete(`api/vehicle/models/${id}`);
}

export function getModelExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/vehicle/models?${fparam}`, {
    responseType: "blob",
  });
}

export function getBrandExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/vehicle/brands?${fparam}`, {
    responseType: "blob",
  });
}

export function getModelImportApi(data){
  return axiosInstance.post('api/vehicle/models',data)
}

export function getBrandImportApi(data){
  return axiosInstance.post('api/vehicle/brands',data)
}

